import isEmpty from "../../is-Empty";
import validator from "validator";

export const LoginValidation = (data) => {
  let errors = {};

  data.number = !isEmpty(data.number) ? data.number : "";
  data.password = !isEmpty(data.password) ? data.password : "";

  if (!validator.isLength(data.number, { min: 10, max: 10 })) {
    errors.number = "Invalid mobile number";
  }
  if (!validator.isLength(data.number, { min: 10, max: 10 })) {
    errors.number = "Mobile number must be 10 digits long.";
  }
  if (validator.isEmpty(data.number)) {
    errors.number = "Mobile number is required";
  }
  if (validator.isEmpty(data.password)) {
    errors.password = "Password is required";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};

export const LoginEmailValidation = (data) => {
  let errors = {};

  data.email = !isEmpty(data.email) ? data.email : "";
  data.password = !isEmpty(data.password) ? data.password : "";

  if (!validator.isEmail(data.email)) {
    errors.email = "Provide a valid email";
  }
  if (validator.isEmpty(data.email)) {
    errors.email = "Email is Required";
  }
  if (validator.isEmpty(data.password)) {
    errors.password = "Password is required";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
